import ActionDetail from './ActionDetail';

export default ActionDetail;
export { ActionDetail };
